import { UserX, LogIn } from "lucide-react";

import { AuthLayout } from "@/components/ui/auth-layout";
import { Button } from "@/components/ui/button";
import { Heading } from "@/components/ui/heading";
import { Panel } from "@/components/ui/panel";
import { Muted, Text } from "@/components/ui/text";
import { backendAuth } from "@/lib/auth/backend-auth";

export default function AccountInactiveRoute() {
  return (
    <AuthLayout>
      <Panel padding="lg" className="space-y-6">
        <div className="flex justify-center">
          <div className="rounded-full bg-amber-100 p-3">
            <UserX className="h-10 w-10 text-amber-700" />
          </div>
        </div>

        <div className="text-center space-y-2">
          <Heading size="lg">Account Inactive</Heading>
          <Muted>Your account has been deactivated.</Muted>
        </div>

        <Text className="text-center">
          Contact an administrator to reactivate your account. After reactivation, sign in again to
          continue.
        </Text>

        <Button
          variant="primary"
          className="w-full"
          onClick={() => backendAuth.login({ returnTo: "/analytics" })}
        >
          <LogIn className="mr-2 h-4 w-4" />
          Try signing in again
        </Button>
      </Panel>
    </AuthLayout>
  );
}
